// extracted by mini-css-extract-plugin
export default {"inviteFriendContainer":"InviteFriend_inviteFriendContainer__ppice","title":"InviteFriend_title__5xBpK","subTitle":"InviteFriend_subTitle__EvMTy","form":"InviteFriend_form__EaNQR"};